<template>
  <div class="st-browser">
    <div class="v-subheader st-browser__header">
      See Bill Payments in these categories:
      <v-layout justify-end>
        <v-btn icon large @click.stop="handleClose" style="color: #999;">
          <v-icon large>close</v-icon>
        </v-btn>
      </v-layout>
    </div>
    <v-alert v-if="showError" type="error" value="true" icon="warning">Failed to load service types.</v-alert>
    <v-layout row wrap v-else>
      <v-flex xs12 sm6 md3 v-for="stg in stBrowser" :key="stg.slug" class="mb-3">
        <v-list>
          <v-list-tile
            ripple
            :inactive="!stg.enabled"
            class="st-browser__stg-tile"
            :class="{'st-browser__stg-tile--disabled': !stg.enabled}"
            @click="stg.enabled ? onSelect(stg) : ()=>{}"> <!-- service type group -->
            <v-list-tile-content>
              <v-list-tile-title :class="{active: stg.active}" class="st-browser__stg-tile-title">{{stg.name}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile
            v-if="stg.children"
            v-for="st in stg.children" :key="`${stg.slug}_${st.slug}`"
            ripple
            :inactive="!st.enabled"
            class="st-browser__st-tile"
            :class="{'st-browser__st-tile--disabled': !st.enabled}"
            @click="st.enabled ? onSelect(stg, st) : ()=>{}"> <!-- service type -->
            <v-list-tile-content>
              <v-list-tile-title :class="{active: st.active}" class="st-browser__st-tile-title">{{st.name}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import {mapState} from 'vuex'

export default {
  props: {
    onSelect: {
      type: Function,
      required: true
    },
    handleClose: {
      type: Function,
      required: false
    }
  },

  computed: {
    ...mapState('geo', ['geo', 'stBrowser']),

    showError () {
      return this.stBrowser.timed_out
    }
  }
}
</script>

<style lang="stylus">
  .st-browser

    @media (min-width: 960px)
      &__header
        font-size: 24px
        font-weight: 500
        padding-left: 16px
 
    &__stg-tile
      &-title
        font-size: 20px
      &--disabled
        color: #aaa
    &__st-tile
      &-title
        font-size: 15px
      &--disabled
        color: #aaa
</style>



// WEBPACK FOOTER //
// frontend/src/pages/Geo/components/ServiceTypeBrowser.vue